import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import EduHeader from './header/EduHeader';
import EduFooter from './footer/EduFooter';
import ScrollToTopButton from '../../components/ScrollToTopButton/ScrollToTopButton';
import usePublicPage from '../auth/hooks/usePublicPage';
import './tokens.css';
import './ui/motion.css';
import './ui/ui.css';

export default function MarketingLayout({ children }) {
  usePublicPage();
  return (
    <div className="mkt">
      <EduHeader />
      <Suspense fallback={<div className="mkt-main" role="status">Loading</div>}>
        <main className="mkt-main" id="main">
          {children || <Outlet />}
        </main>
      </Suspense>
      <EduFooter />
      <ScrollToTopButton />
    </div>
  );
}
